import * as cn from "./ItemDate.scss"

import * as React from "react";

type Props = {
    date: Date
}

export class ItemDate extends React.PureComponent<Props> {
    render() {
        const {date} = this.props

        return (
            <li className = {cn.component}>
                {date.toLocaleString([], {day: "numeric", month: "long"})}
            </li>
        )
    }
}